export enum PolicyConfigDecisionAttributeFieldResultTypes {
    MATCHES = "MATCHES",
    DOES_NOT_MATCH = "NE",
    GREATER_THAN = "GT",
    EQUAL_TO = "EQ",
    LESS_THAN = "LT"
}